import { rootApi } from './baseApi';
import { Sensor, SensorType } from "../types";

interface UpdateSensorRequest {
  sensorId: number;
  sensorName: string;
}

interface AddSensorResponse {
  id: number;
  serialNo: number;
  name: string;
  type: string;
}

interface ZoneSensor {
  sensor_id: number;
  sensor_name: string;
  sensor_serialNo: number;
  zone_ids: string;
}

export const sensorApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getTypes: builder.query<SensorType[], void>({
      query: () => ({
        url: "/types",
        method: "GET"
      }),
      providesTags: ['Sensors']
    }),

    getSensorList: builder.query<Sensor[], void>({
      query: () => ({
        url: "/sensors",
        method: "GET"
      }),
      providesTags: ['Sensors'],
      transformResponse: (response: any[]) => {
        return response.map(sensor => ({
          ...sensor,
          firmware_version: sensor.firmware
        }));
      }
    }),

    addSensor: builder.mutation<AddSensorResponse, any>({
      query: (newSensor) => ({
        url: "/sensors",
        method: "POST",
        body: newSensor
      }),
      transformResponse: (response: any) => {
        return {
          id: response.id,
          serialNo: response.serialNo,
          name: response.name,
          type: response.type
        };
      },
      invalidatesTags: ['Sensors'],
    }),

    updateSensor: builder.mutation({
      query: (updateData: UpdateSensorRequest) => ({
        url: `/sensors/${updateData.sensorId}`,
        method: "PATCH",
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: {
          sensorId: updateData.sensorId,
          sensorName: updateData.sensorName
        }
      }),
      invalidatesTags: ['Sensors'],
    }),

    deleteSensor: builder.mutation({
      query: (sensor) => ({
        url: `/sensors/${sensor.id}`,
        method: "DELETE"
      }),
      invalidatesTags: ['Sensors'],
    }),

    getLiveData: builder.query({
      query: () => ({
        url: '/getLiveData',
        method: 'GET'
      })
    }),

    getZoneSensors: builder.query<ZoneSensor[], number>({
      query: (zoneId) => ({
        url: `/zones/${zoneId}/sensors`,
        method: 'GET'
      })
    }),
  }),
});

// Export the hooks
export const { 
  useGetTypesQuery,
  useGetSensorListQuery,
  useAddSensorMutation,
  useUpdateSensorMutation,
  useDeleteSensorMutation,
  useGetLiveDataQuery,
  useGetZoneSensorsQuery 
} = sensorApi;